import { render, staticRenderFns } from "./DesbloqueiaEmpilhadeira.vue?vue&type=template&id=f1dc87ce&"
import script from "./DesbloqueiaEmpilhadeira.vue?vue&type=script&lang=js&"
export * from "./DesbloqueiaEmpilhadeira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports